export function Logo({ size = "md", className = "" }) {
  const h = size === "lg" ? "h-32" : size === "sm" ? "h-[4.5rem]" : "h-[5.5rem]";
  return (
    <div className={`flex items-center ${className}`} data-testid="app-logo">
      <img src={`${process.env.PUBLIC_URL}/iron-mountain-logo.png`} alt="Iron Mountain Fitness & Health" className={`${h} w-auto object-contain`} />
    </div>
  );
}

export function ProgressRing({ value = 0, size = 120, stroke = 10, label, sub }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (value / 100) * c;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#FF3B30" strokeWidth={stroke}
          strokeDasharray={c} strokeDashoffset={offset} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.8s ease", filter: "drop-shadow(0 0 6px rgba(255,59,48,0.6))" }} />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-heading text-3xl leading-none">{label ?? `${value}%`}</span>
        {sub && <span className="label-xs mt-1">{sub}</span>}
      </div>
    </div>
  );
}

export function StatCard({ label, value, icon: Icon, accent, testId, onClick }) {
  return (
    <div onClick={onClick} data-testid={testId}
      className={`card-surface rounded-xl p-4 transition-all duration-300 ${onClick ? "cursor-pointer hover:-translate-y-1 hover:border-brand" : ""}`}>
      <div className="flex items-center justify-between">
        <span className="label-xs">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-tertiary" />}
      </div>
      <div className={`font-heading text-4xl mt-2 leading-none ${accent ? "text-brand" : ""}`}>{value}</div>
    </div>
  );
}

export function Loader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="w-10 h-10 border-2 border-brand border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export function Pill({ children, tone = "default" }) {
  const tones = {
    default: "bg-white/5 text-secondary",
    success: "bg-success/15 text-success",
    warning: "bg-warning/15 text-warning",
    danger: "bg-brand/15 text-brand",
  };
  return <span className={`text-xs px-2.5 py-1 rounded-full font-semibold ${tones[tone]}`}>{children}</span>;
}
